import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ebb33dd"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2ebb33dd&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ebb33dd')) {
      api.createRecord('2ebb33dd', component.options)
    } else {
      api.reload('2ebb33dd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ebb33dd", function () {
      api.rerender('2ebb33dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotations/request/index.vue"
export default component.exports